import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import OrgUnitAdminUserConstants from '../OrgUnitAdminUserConstants';
import NavLinks from '../../../meet/NavLinks';

import useOmeMeetData from '../../../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetOrgUnitEntryRosterPermissionsData from '../../../../state/omeMeetOrgUnitEntryRosterPermissions/UseOmeMeetOrgUnitEntryRosterPermissionsData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import { credentialsIsComplete, meetInfoIsComplete, rosterEntriesIsComplete } from '../../../../components/leftNavigationOmeTeamEntry/LeftNavValidation';

const INITIAL_VIEW_STATE = {
  reportParameters: { omeMeetOrgUnitEntryId: '' },
  contextId: '',
  routeName: ''
};

const useOrgUnitAdminReporting = () => {
  const navigate = useNavigate();
  const [viewState, setViewState] = useState(INITIAL_VIEW_STATE);
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitEntryInfoState } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetOrgUnitEntryRosterPermissionsState } = useOmeMeetOrgUnitEntryRosterPermissionsData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [state, setState] = useState({ submitButton: '', tryRedirect: false, error: '' });

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.CONTINUE, tryRedirect: true, error: '' });
  };

  const onSaveAndExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.SAVE_AND_EXIT, tryRedirect: true, error: '' });
  };

  const onBackButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.BACK, tryRedirect: true, error: '' });
  };

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId && omeMeetState.objData.meetId) {
      setViewState({
        ...viewState,
        reportParameters: { omeMeetOrgUnitEntryId: omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId },
        contextId: omeMeetState.objData.meetId,
        routeName: 'MEET_ENTRY_TEAM_OUA_TEAMENTRYREPORTING'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, omeMeetState]);

  useEffect(() => {
    if (state.tryRedirect === true) {
      if (state.submitButton === OrgUnitAdminUserConstants.CONTINUE) {
        if (meetInfoIsComplete(omeMeetOrgUnitEntryInfoState.objData, omeMeetOrgUnitEntryRosterPermissionsState.objData) === false ||
          rosterEntriesIsComplete(omeMeetOrgUnitEntryInfoState.objData) === false ||
          credentialsIsComplete(omeMeetOrgUnitEntryInfoState.objData) === false) {
          setState({ ...state, tryRedirect: false, error: 'Meet Info, Roster Entries, and Credentials must be complete before continuing to Submit.' });
        }
        else {
          navigate(NavLinks.OU_ADMIN_PURCHASES);
        }
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.SAVE_AND_EXIT) {
        setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
        navigate(NavLinks.MEET_ENTRY_TEAM, { state: { tryGetOmeMeet: true } });
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.BACK) {
        navigate(NavLinks.OU_ADMIN_CREDENTIALS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, omeMeetOrgUnitEntryInfoState.objData]);

  return {
    ...viewState,
    state,
    onNextButtonClicked, onSaveAndExitButtonClicked, onBackButtonClicked
  };
};

export default useOrgUnitAdminReporting;